module.exports = __webpack_public_path__ + "static/media/truck_green_temp_blue.7f94417b.png";